export const supportedLocales = [
    'en-GB',
    'fi',
    'sv',
    'de',
    'pl',
];
export const isSupportedLocale = (locale) => supportedLocales.includes(locale);
